// extracted by mini-css-extract-plugin
export var announcer = "Carousel-module--announcer--2f288";
export var slide = "Carousel-module--slide--e6613";
export var slides = "Carousel-module--slides--135a7";